import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import { mapState } from 'vuex';
import get from 'lodash/get';
import GaugeChartOptionsEditor from './gauge/gaugeChartOptionsEditor.vue';
import ChartCustomOptionsEditor from './custom/chartCustomOptionsEditor.vue';
import LineBarChartOptionsEditor from './line-bar/lineBarChartOptionsEditor.vue';
import WidgetChartToolboxEditor from './widgetChartToolboxEditor.vue';
import HeatmapChartOptionsEditor from './heatmap/heatmapChartOptionsEditor.vue';
export default {
  name: 'WidgetChartOptionsEditor',
  components: {
    GaugeChartOptionsEditor,
    ChartCustomOptionsEditor,
    LineBarChartOptionsEditor,
    WidgetChartToolboxEditor,
    HeatmapChartOptionsEditor
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    }
  },
  data() {
    const chartTypeValues = ['bar', 'line', 'gauge', 'heatmap', 'custom'];
    return {
      chartTypes: chartTypeValues.map(type => ({
        text: this.$t(`Dashboards.chartTypes.${type}`),
        value: type
      }))
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    editedWidget: {
      get() {
        const chartOptions = get(this.value, 'chartOptions', {});
        return {
          ...this.value,
          chartOptions
        };
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    showLegend: {
      get() {
        return get(this.editedWidget, 'chartOptions.legend.show', true);
      },
      set(value) {
        this.setByKey('chartOptions.legend.show', value);
      }
    }
  },
  watch: {
    'editedWidget.chartOptions.type': {
      handler(newVal) {
        if (!newVal) {
          this.setByKey('chartOptions.type', 'line');
        }
      },
      immediate: true
    }
  },
  methods: {
    setByKey(key, val) {
      const clone = cloneDeep(this.editedWidget);
      if (key === 'chartOptions.type') {
        delete clone.chartOptions[clone.chartOptions.type];
      }
      set(clone, key, val);
      if (clone.chartOptions.type === 'custom') {
        clone.chartOptions.custom = clone.chartOptions.custom || {
          optionGenerator: ''
        };
      }
      this.$emit('input', clone);
    },
    getByKey(key, defaultValue) {
      return get(this.editedWidget, key, defaultValue);
    }
  }
};